// Local-storage helpers for Saved & Compare lists.
const SAVED_KEY = "ssc_saved_vehicles";
const COMPARE_KEY = "ssc_compare_vehicles";

export const COMPARE_LIMIT = 6;

const read = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k) || "[]");
  } catch {
    return [];
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
    window.dispatchEvent(new Event("ssc-storage"));
  } catch {}
};

export const savedStore = {
  list: () => read(SAVED_KEY),
  has: (slug) => read(SAVED_KEY).some((v) => v.slug === slug),
  toggle: (vehicle) => {
    const arr = read(SAVED_KEY);
    const idx = arr.findIndex((v) => v.slug === vehicle.slug);
    if (idx >= 0) arr.splice(idx, 1);
    else arr.push(vehicle);
    write(SAVED_KEY, arr);
    return read(SAVED_KEY);
  },
  remove: (slug) => write(SAVED_KEY, read(SAVED_KEY).filter((v) => v.slug !== slug)),
};

// Compare store returns a status object from `add` so callers (VDP / cards)
// can show toast feedback when the 6-vehicle cap is hit.
export const compareStore = {
  list: () => read(COMPARE_KEY),
  has: (slug) => read(COMPARE_KEY).some((v) => v.slug === slug),
  count: () => read(COMPARE_KEY).length,
  limit: COMPARE_LIMIT,
  add: (vehicle) => {
    const arr = read(COMPARE_KEY);
    if (arr.some((v) => v.slug === vehicle.slug)) {
      return { ok: false, reason: "already_added", count: arr.length };
    }
    if (arr.length >= COMPARE_LIMIT) {
      return { ok: false, reason: "limit", count: arr.length };
    }
    arr.push(vehicle);
    write(COMPARE_KEY, arr);
    return { ok: true, count: arr.length };
  },
  toggle: (vehicle) => {
    const arr = read(COMPARE_KEY);
    const idx = arr.findIndex((v) => v.slug === vehicle.slug);
    if (idx >= 0) {
      arr.splice(idx, 1);
      write(COMPARE_KEY, arr);
      return { ok: true, removed: true, count: arr.length };
    }
    if (arr.length >= COMPARE_LIMIT) {
      return { ok: false, reason: "limit", count: arr.length };
    }
    arr.push(vehicle);
    write(COMPARE_KEY, arr);
    return { ok: true, count: arr.length };
  },
  remove: (slug) => write(COMPARE_KEY, read(COMPARE_KEY).filter((v) => v.slug !== slug)),
  clear: () => write(COMPARE_KEY, []),
};
